<template lang="html">
  <section v-if="visible" v-on:click="onSelected">
    <div class="m-list-option" :id="itemId">
      <svg
        class="fields-icon slds-icon_container slds-icon--x-small slds-icon-text-default"
        v-if="hasIcon"
      >
        <use :xlink:href="getUtilityIcon(listItem)"></use>
      </svg>
      <div class="m-text-items">
        <div class="m-ellipsis" v-html="text"></div>
      </div>
      <div
        class="m-label-content-type"
        v-if="listItem.isTemplate !== undefined && listItem.isTemplate !== null"
      >
        {{ pageTypeLabel }}
      </div>
    </div>
    <b-tooltip
      :target="itemId"
      :title="getValue()"
      variant="info"
      delay="1300"
    ></b-tooltip>
  </section>
</template>

<script lang="js">
  import { highlight } from "@/components/utils/highlight";
  import iconsUri from "@/views/drag-drop-pages/components/utils/icons-uri";
  export default  {
    name: 'search-box-list-item-simple',
    props: {
      listItem: {
        type: Object
      },
      exp: {
        type: String
      },
      itemId: {
        type: String
      },
      hasIcon: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      pageTypeLabel() {
        return this.listItem.isTemplate ? this.$t("pageTemplate") : this.$t("page");
      }
    },
    mounted() {
      this.text = this.getValue();
      this.updateDisplay();
    },
    watch: {
      exp: function() {
        this.updateDisplay();
      }
    },
    data () {
      return {
        text: "",
        visible: true
      }
    },
    methods: {
      getUtilityIcon(item) {
        return iconsUri.getUtilityIconByType(item.dataType);
      },
      getValue() {
        return this.listItem.label || this.listItem.name || "";
      },
      onSelected() {
        if(this.$listeners && this.$listeners["on-search-box-item-selected"]) {
          this.$emit("on-search-box-item-selected", this.listItem);
        }
      },
      updateDisplay() {
        this.visible = true;
        const value = this.getValue();
        if(this.exp) {
          this.text = highlight.find(value, this.exp);
          if(this.text === value) {
            this.visible = false;
          }
        } else {
          this.text = value;
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../styles/components/elements";
  .m-list-option-icon {
    svg {
      @include mixin-list-item-svg-icon;
    }
    padding: 0.188rem 0.75rem;
    margin-right: -0.75rem;
  }

  .m-list-option {
    display: flex;
    align-items: center;
  }
  .m-text-items {
    overflow: hidden;
    padding: 0.75rem;
  }

  .b-tooltip {
    z-index: 10000;
  }

  .m-label-content-type {
    margin-left: auto;
    padding-right: 1rem;
    color: var(--TEXT_GREY_LIGHT);
  }
</style>
